import { composeClassNames } from "@faedev/editor-utils";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { Card } from "react-bootstrap";
import Favorite from "src/components/Favorite";
import Rating from "src/components/Rating";
import constants from "src/constants";
import getLink from "src/functions/getLink";
import gutter from "src/functions/gutter";
import { sLink } from "src/styles/sLink.module.scss";
import { sVideoCard } from "src/styles/sVideoCard.module.scss";
import { sVideoCardBody } from "src/styles/sVideoCardBody.module.scss";
import { sVideoCardOverlay } from "src/styles/sVideoCardOverlay.module.scss";
import { ApiVideoCard } from "src/types/ApiVideoCard";
import { VariantSize } from "src/types/VariantSize";
import { VariantVideoPreview } from "src/types/VariantVideoPreview";
import MerchPrice from "./MerchPrice";
import NftNumber from "./NftNumber";

type Props = {
  className?: (string | string) | null | undefined;
  size: VariantSize;
  type: VariantVideoPreview;
  data?: ApiVideoCard;
};

function NftCard({ className, size, type, data }: Props) {
  const { locale: lang } = useRouter();
  const thumbnailFromStrapi = typeof data.image?.url === "string";

  return data ? (
    <>
      <Card
        className={composeClassNames([
          sVideoCard,
          type,
          size,
          className,
          "video",
        ])}
        id={`video${data.id}`}
      >
        <div className="card-img-wrapper-square">
          <Image
            src={thumbnailFromStrapi && data.image.url}
            alt={data.title}
            layout="fill"
            objectFit="contain"
            className="card-img"
          />
          <Card.ImgOverlay
            className={composeClassNames([
              sVideoCardOverlay,
              type,
              size,
              "video-overlay",
            ])}
          >
            <Rating
              value={data.rating}
              size={size}
              className={`video-rating`}
              colors={{
                default: constants.Theme.white,
                active: constants.Theme.white,
              }}
            />
            <Favorite
              setByUser={true}
              size={size}
              className={`video-favorite`}
              colors={{
                default: constants.Theme.white,
                active: constants.Theme.white,
              }}
              value={true}
            />
            <NftNumber value={data.order} className={`video-class-serial-no`} />
            <MerchPrice
              size={size}
              className={`video-content-type`}
              price={data.price}
              priceCurrency={data.priceCurrency}
            />
            <Link
              href={
                data.paid || !constants.Show.contentSamplesInModal
                  ? getLink(lang, "nft", data.url)
                  : `#video${data.id}`
              }
              passHref
              locale={lang}
            >
              <Card.Link className={composeClassNames([sLink, `img-link`])} />
            </Link>
          </Card.ImgOverlay>
        </div>
        <Card.Body
          className={composeClassNames([sVideoCardBody, size, "video-body"])}
        >
          <Card.Title>
            <Link
              href={
                data.paid || !constants.Show.contentSamplesInModal
                  ? getLink(lang, "nft", data.url)
                  : `#video${data.id}`
              }
              passHref
              locale={lang}
            >
              <Card.Link className={composeClassNames([sLink, `video-link`])}>
                {data.title}
              </Card.Link>
            </Link>
          </Card.Title>
          {(function () {
            switch (type) {
              case `preview`:
                return (
                  <>
                    <Card.Text style={gutter(`margin`, `all`, `0`)}>
                      <Link
                        href={getLink(lang, `profile`, data.profile.url)}
                        passHref
                        locale={lang}
                      >
                        <Card.Link
                          className={composeClassNames([sLink, `video-link`])}
                        >
                          {data.profile.nickname}
                        </Card.Link>
                      </Link>
                    </Card.Text>
                    <Card.Text className={`video-label`}>
                      {data.label}
                    </Card.Text>
                  </>
                );
            }
          })()}
        </Card.Body>
      </Card>
    </>
  ) : null;
}

export default NftCard;
